import { useMemo } from "react";
import { useSelector } from "react-redux";
import { FilterValues } from "../../../data-model/filterValues";
import { TableNames } from "../../../enums/tableNames";
import { RootState } from "../../../redux/store/store";

/**
 * Filters the redux filter values down to the ones applied to this table.
 *
 * @input tableName - Table whose filters to read; defaults to the non-ePA list
 * @return Filter values applied to the table
 */
export const useValidFilters = (
  tableName: TableNames = TableNames.CALLING_WORKLIST_ORDERS,
): FilterValues[] => {
  const { filters } = useSelector((state: RootState) => state.filterValues);

  const validFilters = useMemo(() => {
    return filters.filter((filter) => filter.name === tableName);
  }, [filters, tableName]);

  return validFilters;
};
